import ExtensionIcon from '@material-ui/icons/Extension';
import JigsawEventsCreate from './components/JigsawEventsCreate';
import JigsawEventsEdit from './components/JigsawEventsEdit';
import JigsawEventsList from './components/JigsawEventsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.HUNGARY, APP_TYPES.IRELAND],
  allowedRoles: [roles.ADMIN],
  label: 'Jigsaw Events',
  subMenuName: 'dailyGames',
};

export default {
  create: JigsawEventsCreate,
  list: JigsawEventsList,
  edit: JigsawEventsEdit,
  icon: ExtensionIcon,
  name: 'admin/jigsaw',
  options,
};
